"use strict";

// eslint-disable-next-line
export default (Vue, options) => {
  Vue.mixin({
    computed: {
      isValidForm() {
        if (!this.fields) {
          return true;
        }

        return Object.keys(this.fields).every(name => {
          return this.fields[name] && this.fields[name].valid;
        });
      }
    }
  });
};
